import { api } from "../api";

/**
 * ticketUpdateStatusById - Function that updates on database an existing ticket status by id   
 * /tickts/{id}/{status}  
 * method PUT 
 * @async-function
 */
const ticketUpdateStatusById = async (token: string, id: number, status: string) => {
    const response = await api.put(
        `/tickets/${id}/${status}`, {}, {
             headers: { 'Authorization': `Bearer ${token}` }
        });

    return response;
};

export default ticketUpdateStatusById;
